import { supabase } from './supabase';

function toDateOnly(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string') return value.split('T')[0];
  return String(value);
}

function buildMetadata(payload) {
  return {
    location: payload.location ?? null,
    offerId: payload.offerId ?? null,
    hotelId: payload.hotelId ?? null,
    isRealBooking: payload.isRealBooking ?? false,
    specialRequests: payload.guestData?.specialRequests ?? null,
  };
}

/**
 * Persist a checkout payload for the logged-in app user (trusted RPC: id + email).
 */
export async function saveBookingTrusted(user, payload) {
  const guest = payload.guestData || {};
  const checkIn = toDateOnly(payload.checkIn);
  const checkOut = toDateOnly(payload.checkOut);
  const nights =
    payload.nights != null
      ? Number(payload.nights)
      : null;

  const adults = Math.max(1, Number(payload.guests) || 1);
  const total =
    payload.total != null && payload.total !== ''
      ? Number(payload.total)
      : null;

  const { data, error } = await supabase.rpc('save_booking_trusted', {
    p_user_id: user.id,
    p_session_email: user.email,
    p_check_in: checkIn,
    p_check_out: checkOut,
    p_hotel_property_id: payload.hotelId != null ? String(payload.hotelId) : null,
    p_hotel_name: payload.hotelName || null,
    p_nights: Number.isFinite(nights) ? nights : null,
    p_adults: adults,
    p_children: 0,
    p_guest_first_name: guest.firstName || null,
    p_guest_last_name: guest.lastName || null,
    p_guest_email: guest.email || null,
    p_guest_phone: guest.phone || null,
    p_nationality: guest.nationality || null,
    p_currency: 'GBP',
    p_room_summary: payload.roomType || null,
    p_total_price: Number.isFinite(total) ? total : null,
    p_confirmation_ref: payload.confirmationNumber || null,
    p_metadata: buildMetadata(payload),
    p_status: 'confirmed',
  });

  if (error) {
    throw new Error(error.message || 'Could not save booking');
  }
  if (!data || !data.success) {
    throw new Error(data?.error || 'Could not save booking');
  }
  return data;
}

/**
 * Load saved bookings for the current session user.
 */
export async function listBookingsTrusted(user) {
  const { data, error } = await supabase.rpc('list_bookings_trusted', {
    p_user_id: user.id,
    p_session_email: user.email,
  });

  if (error) {
    throw new Error(error.message || 'Could not load bookings');
  }
  if (!data || !data.success) {
    throw new Error(data?.error || 'Could not load bookings');
  }

  const rows = data.bookings;
  if (Array.isArray(rows)) {
    return rows;
  }
  if (rows && typeof rows === 'string') {
    try {
      const parsed = JSON.parse(rows);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}
